import { useState, useEffect } from "react";
import { InsuranceFormType } from "../../models/forms/insurance";
import { InsuranceForm } from "./insuranceForm.component";
import { ApiInsuranceTypes } from "../../core/apis/insuranceTypes";
import { useHistory, useParams } from "react-router-dom";
import { SpinLoader } from "../../components/spinLoader.component";
import { AppRouteUi } from "../../config/appRoute";

export const UpdateInsurance = () => {
  const routeHistory = useHistory();
  const { insuranceId } = useParams<{ insuranceId: string }>();
  const { data, isValidating } = ApiInsuranceTypes.ById.Hook(insuranceId);

  const [value, setValue] = useState<InsuranceFormType | undefined>(data);

  useEffect(() => setValue(data), [data]);

  const handleSaveCallback = async (val: InsuranceFormType) => {
    const res = await ApiInsuranceTypes.Update({
      ...val,
      sKey: data?.sKey ?? "",
    });
    if (res.data.isSuccess)
      routeHistory.length > 1
        ? routeHistory.goBack()
        : routeHistory.push(AppRouteUi.Root);
  };

  if (isValidating) return <SpinLoader />;

  return (
    <InsuranceForm
      value={value}
      onChange={setValue as any}
      handleSave={handleSaveCallback}
    />
  );
};
